import { render, staticRenderFns } from "./RedirectionForm.vue?vue&type=template&id=42d894b7&"
import script from "./RedirectionForm.vue?vue&type=script&lang=js&"
export * from "./RedirectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports